import { twMerge } from "tailwind-merge";
import { PartItem } from ".";

type Props = {
  items: any[];
  classList?: string;
};

export default function PartList({ items, classList }: Props) {
  const isGrouped = items[0]?.items;
  if (isGrouped) {
    return (
      <div>
        {items.map((section) => {
          if (!section.items.length) return null;
          return (
            <div
              key={section.group}
              className={twMerge(
                "grid border-b pb-8 last:border-b-0 md:grid-cols-6",
                classList,
              )}
            >
              <h3 className="sticky top-10 z-10 place-self-start bg-white py-2 pr-4 text-2xl font-light">
                <span>{section.group}</span>
                {section.description && (
                  <span className="block text-sm">{section.description}</span>
                )}
              </h3>
              <div className="md:col-span-5">
                <PartList items={section.items} />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div
      className={twMerge(
        "grid gap-10",
        "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
        classList,
      )}
    >
      {items.map((props, idx) => (
        <PartItem key={idx} {...props} />
      ))}
    </div>
  );
}
